// assets/custom.js — Amusement Co custom theme JS (isolated; do not edit theme.js)
// Linked in the <head> via the theme's script tag (or a settings snippet).

document.addEventListener('DOMContentLoaded', () => {
  // Enquiry form drawer open/close
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-enquiry-open]');
    if (open) {
      const drawer = document.getElementById(open.getAttribute('aria-controls'));
      if (drawer && typeof drawer.show === 'function') drawer.show();
    }
  });

  // On enquiry form submit success, refresh the UI if the theme exposes it
  document.addEventListener('submit', (e) => {
    if (e.target.matches('form.enquiry-form__form')) {
      // Let the native contact form submit; optionally push to AITable via webhook later.
      e.target.dataset.enquirySubmitted = 'true';
    }
  });

  // Cart events — keep cross-sell/cart UI in sync (reuse the theme's events)
  document.addEventListener('cart:change', (event) => {
    const cart = event.detail && event.detail.cart;
    if (cart && window.enquiryCrossSell) window.enquiryCrossSell(cart);
  });
  document.addEventListener('cart:refresh', () => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  });
});


// Hide product-page accordion tabs that carry no real information, along with their divider.
// A label with no value under it counts as empty. That is exactly what the Details tab looks like
// before Specifications and What's Included have data: two headings and nothing else, which the old
// text check happily counted as content, so the tab stayed on the page.
function amcHideEmptyAccordions() {
  document.querySelectorAll('#product-extra-information .accordion__content').forEach(function (content) {
    // 1. drop any heading with nothing under it before the next heading
    var kids = Array.prototype.slice.call(content.children);
    for (var i = kids.length - 1; i >= 0; i--) {
      var el = kids[i];
      if (!/^H[1-6]$/.test(el.tagName)) continue;
      var hasValue = false;
      for (var j = i + 1; j < kids.length; j++) {
        if (/^H[1-6]$/.test(kids[j].tagName)) break;
        if ((kids[j].textContent || '').replace(/\s+/g, '') !== '' ||
            kids[j].querySelector('img, video, iframe, table')) { hasValue = true; break; }
      }
      if (!hasValue && el.parentNode) el.parentNode.removeChild(el);
    }
    // 2. if nothing meaningful is left, hide the whole accordion so its divider goes with it
    var text = (content.textContent || '').replace(/\s+/g, '');
    var hasMedia = content.querySelector('img, video, iframe, table');
    if (text || hasMedia) return;
    var wrap = content.closest('accordion-disclosure') || content.closest('details') || content.parentElement;
    if (wrap) wrap.style.display = 'none';
  });
}
document.addEventListener('DOMContentLoaded', amcHideEmptyAccordions);
document.addEventListener('variant:change', function () { setTimeout(amcHideEmptyAccordions, 300); });
// metafield driven content can land after first paint, so check again
setTimeout(amcHideEmptyAccordions, 900);
setTimeout(amcHideEmptyAccordions, 2000);


// Enquiry form: two-step navigation (project details, then contact details)
document.addEventListener('click', function (e) {
  var next = e.target.closest('[data-enquiry-next]');
  if (next) {
    var form = next.closest('form');
    if (!form) return;
    var ok = true;
    form.querySelectorAll('[data-enquiry-step="1"] [required]').forEach(function (f) {
      if (!f.checkValidity()) { f.reportValidity(); ok = false; }
    });
    if (!ok) return;
    form.querySelector('[data-enquiry-step="1"]').hidden = true;
    form.querySelector('[data-enquiry-step="2"]').hidden = false;
    var p = form.querySelector('[data-enquiry-progress]');
    var bar = form.querySelector('[data-enquiry-progress-bar]');
    if (bar) bar.setAttribute('aria-valuenow', '2');
    if (p) p.textContent = 'Step 2 of 2';
    return;
  }
  var back = e.target.closest('[data-enquiry-back]');
  if (back) {
    var f2 = back.closest('form');
    if (!f2) return;
    f2.querySelector('[data-enquiry-step="2"]').hidden = true;
    f2.querySelector('[data-enquiry-step="1"]').hidden = false;
    var p2 = f2.querySelector('[data-enquiry-progress]');
    var bar2 = f2.querySelector('[data-enquiry-progress-bar]');
    if (bar2) bar2.setAttribute('aria-valuenow', '1');
    if (p2) p2.textContent = 'Step 1 of 2';
  }
});


// FAQ: one answer open at a time. We CLICK the other summaries rather than setting .open,
// so the theme's own toggle logic runs - that keeps the + / - icon and aria-expanded in sync
// and gives us the theme's closing animation instead of an abrupt snap.
document.addEventListener('click', function (e) {
  var sum = e.target.closest('.shopify-section--faq summary');
  if (!sum) return;
  var d = sum.closest('details');
  if (!d || d.open) return; // already open = user is closing it, leave the rest alone
  var sec = d.closest('.shopify-section--faq');
  if (!sec) return;
  sec.querySelectorAll('details[open]').forEach(function (other) {
    if (other === d) return;
    var s = other.querySelector('summary');
    if (s) s.click();
  });
}, true);

// ---------------------------------------------------------------------------


// ---------------------------------------------------------------------------
// Product-page ADD-ONS (rendered by the draggable "Add-ons" block)
// 1. keeps the collapsed summary label in sync with the chosen option
// 2. moves the LIVE price: product price + chosen add-ons, on the price block AND the CTA
// 3. adds the chosen add-ons to the cart with the product
// ---------------------------------------------------------------------------
(function () {
  function fmt(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function parseMoney(t) { var m = (t || '').replace(/,/g, '').match(/[0-9]+(\.[0-9]+)?/); return m ? parseFloat(m[0]) : null; }

  function picks() {
    var out = [];
    document.querySelectorAll('.amc-addons input[data-amc-addon]:checked').forEach(function (i) {
      if (i.value && parseFloat(i.dataset.price || '0') > 0) out.push({ id: i.value, label: i.dataset.label, price: parseFloat(i.dataset.price) });
    });
    return out;
  }

  function basePrice() {
    var el = document.querySelector('.product-info .price-list, .product-info [class*="price-list"]');
    if (!el) return null;
    if (!el.dataset.amcBase) el.dataset.amcBase = el.innerHTML;
    return parseMoney(el.dataset.amcBase.replace(/<[^>]*>/g, ' '));
  }

  function sync() {
    // collapsed summary labels
    document.querySelectorAll('.amc-addons [data-amc-group]').forEach(function (g) {
      var sel = g.querySelector('input[data-amc-addon]:checked');
      var lab = g.querySelector('[data-amc-current]');
      if (sel && lab) lab.textContent = sel.dataset.label;
    });
    var chosen = picks();
    var add = chosen.reduce(function (t, c) { return t + c.price; }, 0);

    // live price on the page
    var base = basePrice();
    var priceEl = document.querySelector('.product-info .price-list, .product-info [class*="price-list"]');
    if (priceEl && base !== null) {
      if (add > 0) {
        priceEl.innerHTML = '<span class="amc-price-total">' + fmt(base + add) + '</span>' +
          '<span class="amc-price-note">includes ' + fmt(add) + ' in add-ons</span>';
      } else {
        priceEl.innerHTML = priceEl.dataset.amcBase;
      }
    }

    // live price on the CTA
    var btn = document.querySelector('.product-info [data-block-type="buy-buttons"] button[type="submit"], .product-info [data-block-type="buy-buttons"] button[name="add"]');
    if (btn) {
      if (!btn.dataset.amcBase) btn.dataset.amcBase = btn.innerHTML;
      btn.innerHTML = base !== null ? btn.dataset.amcBase + '<span class="amc-cta-price">' + fmt(base + add) + '</span>' : btn.dataset.amcBase;
    }

    // running total line
    var tot = document.querySelector('[data-amc-total]');
    if (tot) {
      if (add > 0) { tot.hidden = false; tot.textContent = 'Add-ons: ' + fmt(add); }
      else { tot.hidden = true; }
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.amc-addons')) sync();
  });
  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('variant:change', function () { setTimeout(sync, 250); });
  document.addEventListener('shopify:section:load', function () { setTimeout(sync, 250); });

  // add the chosen add-ons alongside the product on submit
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.amcAddonsDone === '1') return;
    if (!/^product-form-main-/.test(form.id || '')) return;
    var chosen = picks();
    if (!chosen.length) return;
    e.preventDefault();
    Promise.all(chosen.map(function (c) {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(c.id), quantity: 1, properties: { '_add-on for': document.title } }] })
      });
    })).then(function () { form.dataset.amcAddonsDone = '1'; if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
  }, true);
})();


/* AMC: sticky-bar quote CTA opens the product enquiry drawer */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-amc-sticky-enquiry]');
    if (!trigger) return;
    var opener = document.querySelector('[data-enquiry-open]');
    if (opener) { event.preventDefault(); opener.click(); }
  });
})();


// Enquiry form spam guard: the hidden company field is a honeypot and the form must not be
// submitted within 3 seconds of the page loading. Bots that trip either one get a fake success.
(function () {
  var loadedAt = Date.now();
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form.enquiry-form__form')) return;
    var trap = form.querySelector('input[name="contact[company]"]');
    var tooFast = (Date.now() - loadedAt) < 3000;
    if ((trap && trap.value !== '') || tooFast) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var done = form.querySelector('.enquiry-success');
      if (done) { done.hidden = false; }
      form.style.display = 'none';
    }
  }, true);
})();

/* Storefront captcha on the enquiry form.
   Shopify's provider renders hCaptcha with data-size="invisible" unless the form already contains a
   .h-captcha element, in which case it reuses that one as-is. That is why buyers never saw a captcha.
   So we place a visible (checkbox) one, and we never rely on hCaptcha.execute() resolving: once a
   response token exists we submit with the real native submit, which is what Shopify validates. */
(function () {
  var FALLBACK_KEY = 'f06e6c50-85a8-45c8-87d0-21a2b65856fe';
  var UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

  function sitekey() {
    var boot = document.getElementById('captcha-bootstrap');
    var m = boot && boot.textContent ? boot.textContent.match(UUID) : null;
    return m ? m[0] : FALLBACK_KEY;
  }

  function slot(form) {
    var s = form.querySelector('[data-amc-captcha-slot]');
    if (s) return s;
    s = document.createElement('div');
    s.className = 'amc-captcha';
    s.setAttribute('data-amc-captcha-slot', '');
    var label = document.createElement('p');
    label.className = 'amc-captcha__label';
    label.textContent = 'Confirm you are human, then send your request.';
    s.appendChild(label);
    // bottom of step 2, immediately before the send button
    var btn = form.querySelector('.enquiry-submit') || form.querySelector('button[type=submit]');
    if (btn && btn.parentNode) btn.parentNode.insertBefore(s, btn);
    else form.appendChild(s);
    return s;
  }

  function place(form) {
    var s = slot(form);
    var w = form.querySelector('.h-captcha');
    if (!w) {
      w = document.createElement('div');
      w.className = 'h-captcha';
      w.setAttribute('data-sitekey', sitekey());
      w.setAttribute('data-size', 'normal');
      s.appendChild(w);
    } else if (w.parentNode !== s) {
      s.appendChild(w);
    }
    var resp = form.querySelector('textarea[name="h-captcha-response"], input[name="h-captcha-response"]');
    if (resp && resp.parentNode !== s) s.appendChild(resp);
    return w;
  }

  function token(form) {
    var el = form.querySelector('[name="h-captcha-response"]');
    return el && el.value && el.value.length > 10 ? el.value : null;
  }

  function wire() {
    var form = document.querySelector('form.enquiry-form__form');
    if (!form) return false;
    place(form);
    if (!form.dataset.amcCaptchaWired) {
      form.dataset.amcCaptchaWired = '1';
      new MutationObserver(function () { place(form); }).observe(form, { childList: true, subtree: true });
      function renderIfHidden() {
        var w = form.querySelector('.h-captcha');
        if (!w || !window.hcaptcha || typeof window.hcaptcha.render !== 'function') return;
        var f = w.querySelector('iframe');
        if (f && f.getBoundingClientRect().width > 50) return;
        w.innerHTML = '';
        try {
          window.hcaptcha.render(w, { sitekey: w.getAttribute('data-sitekey') || FALLBACK_KEY, size: 'normal' });
        } catch (e) {}
      }
      document.addEventListener('click', function (event) {
        if (!event.target || !event.target.closest) return;
        if (event.target.closest('[data-enquiry-next]')) setTimeout(renderIfHidden, 350);
        if (event.target.closest('[data-enquiry-open]')) setTimeout(renderIfHidden, 900);
      });
      setTimeout(renderIfHidden, 1500);

      // If the buyer solved the captcha, send it with a real native submit instead of waiting on
      // hCaptcha.execute(), which never resolves when the challenge is not interactive.
      form.addEventListener('submit', function (event) {
        if (!token(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        HTMLFormElement.prototype.submit.call(form);
      }, true);
    }
    return true;
  }

  if (!wire()) {
    var obs = new MutationObserver(function () { if (wire()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Quote products: the theme reveals the sticky bar from the product form, and the enquiry
   template hides that form, so the bar never appeared on quote pages. Drive it from the
   enquiry CTA instead, using the theme's own is-visible class. */
(function () {
  function wire() {
    var bar = document.querySelector('product-sticky-bar');
    var form = document.querySelector('form.enquiry-form__form');
    var cta = document.querySelector('[data-enquiry-open]');
    if (!bar || !form) return false;
    function update() {
      var past = cta ? cta.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
      bar.classList.toggle('is-visible', past);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    setTimeout(update, 400);
    return true;
  }
  if (!wire()) {
    var obs = new MutationObserver(function () { if (wire()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Stock line and lead time, product page and quick view.
   The theme prints "Only 5 units left" and re-renders on every variant change. We rewrite it in the
   same frame the theme writes it: an early document observer catches the element the moment it is
   injected, a per-element observer catches later re-renders, and CSS keeps the theme's own wording
   invisible until our rewrite has landed, so "units" can never be painted. */
(function () {
  function words(n, availability) {
    if (n > 0) return n <= 10 ? 'Only ' + n + ' left' : 'In stock';
    if (/made/i.test(availability || '')) return 'Made to order';
    return 'In stock';
  }
  function attr(scope, name) {
    var meta = scope && scope.querySelector ? scope.querySelector('[data-amc-product-meta]') : null;
    if (!meta) meta = document.querySelector('[data-amc-product-meta]');
    return meta ? (meta.getAttribute(name) || '') : '';
  }
  function watch(el) {
    if (!el || el.dataset.amcStockWatch) return;
    el.dataset.amcStockWatch = '1';
    new MutationObserver(run).observe(el, { childList: true, characterData: true, subtree: true });
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-info'), function (scope) {
      var availability = attr(scope, 'data-availability');
      var lead = attr(scope, 'data-lead');
      var theme = scope.querySelector('[data-block-type="inventory"]');
      var own = scope.querySelector('.amc-stock');
      var stockEl = null;
      if (theme) {
        var m = (theme.textContent || '').match(/(\d+)/);
        var want = words(m ? parseInt(m[1], 10) : 0, availability);
        var target = theme.querySelector('.inventory__text') || theme.querySelector('span') || theme;
        if (target.textContent !== want) target.textContent = want;
        if (theme.style.display === 'none') theme.style.display = '';
        theme.classList.add('amc-stock-ready');
        theme.classList.toggle('amc-stock-low', /^Only /.test(want));
        theme.classList.toggle('amc-stock-in', /^In stock/i.test(want));
        if (own) own.remove();
        watch(theme);
        stockEl = theme;
      } else {
        var anchor = scope.querySelector('[data-block-type="quantity-selector"]') ||
                     scope.querySelector('[data-block-type="buy-buttons"]') ||
                     scope.querySelector('[data-block-type="enquiry-form"]') ||
                     scope.querySelector('[data-block-type="complementary-products"]');
        if (!anchor || !anchor.parentNode) return;
        var want2 = words(0, availability);
        if (!own) {
          own = document.createElement('div');
          own.className = 'amc-stock';
          anchor.parentNode.insertBefore(own, anchor);
        }
        if (own.textContent !== want2) own.textContent = want2;
        own.classList.toggle('amc-stock--low', /^Only /.test(want2));
        own.classList.toggle('amc-stock--in', /^In stock/i.test(want2));
        stockEl = own;
      }
      var ld = scope.querySelector('.amc-lead');
      // When we hold no verified lead time, say so plainly rather than printing nothing. Beno's
      // wording: lead time confirmed on your quote. No dot, because a dot is a status signal and
      // this is the absence of one. That keeps green meaning genuinely ready to ship.
      var leadText = lead || 'Lead time confirmed on your quote';
      // stock line sits above the quantity selector, lead time sits below it
      var qty = scope.querySelector('[data-block-type="quantity-selector"]');
      var after = qty || stockEl;
      if (!after || !after.parentNode) return;
      if (!ld) {
        ld = document.createElement('div');
        ld.className = 'amc-lead';
        after.parentNode.insertBefore(ld, after.nextSibling);
      } else if (after.nextElementSibling !== ld) {
        after.parentNode.insertBefore(ld, after.nextSibling);
      }
      if (ld.textContent !== leadText) ld.textContent = leadText;
      var cls = 'amc-lead' + (lead && !/made/i.test(availability) ? ' amc-lead--ready' : '');
      if (ld.className !== cls) ld.className = cls;
    });
  }
  window.amcStockRun = run;
  // arm at parse time so the theme's first render is caught, not missed
  var early = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.nodeType === 1 && t.closest && t.closest('.product-info')) { run(); return; }
    }
  });
  try { early.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  setTimeout(function () { try { early.disconnect(); } catch (e) {} }, 20000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 300);
  setTimeout(run, 1200);
  document.addEventListener('variant:change', run);
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 200); });
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('[class*="quick-add"], [class*="quick-buy"]')) setTimeout(run, 400);
  }, true);
  document.addEventListener('change', function () { setTimeout(run, 50); }, true);
})();

/* Live price inside the quick view add to cart button, same treatment as the product page. */
(function () {
  function priceOf(scope) {
    var el = scope.querySelector('.price-list');
    if (!el) return null;
    var m = (el.textContent || '').match(/\$[\d,]+\.\d{2}/);
    return m ? m[0] : null;
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('quick-buy-modal .product-info, .quick-buy-modal .product-info, dialog .quick-buy-modal__info-wrapper'), function (scope) {
      var btn = scope.querySelector('[data-block-type="buy-buttons"] button[type="submit"]');
      var text = priceOf(scope);
      if (!btn || !text) return;
      var span = btn.querySelector('.amc-cta-price');
      if (!span) { span = document.createElement('span'); span.className = 'amc-cta-price'; btn.appendChild(span); }
      if (span.textContent !== text) span.textContent = text;
      var list = scope.querySelector('.price-list');
      if (list && !list.dataset.amcPriceWatch) {
        list.dataset.amcPriceWatch = '1';
        new MutationObserver(function () { run(); }).observe(list, { childList: true, characterData: true, subtree: true });
      }
    });
  }
  window.amcQuickPriceRun = run;
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    if (event.target.closest('[class*="quick-add"], [class*="quick-buy"]')) { setTimeout(run, 400); setTimeout(run, 1200); }
  }, true);
  document.addEventListener('variant:change', function () { setTimeout(run, 100); });
  setTimeout(run, 1500);
})();

/* Empty collections are dead ends, and a dead end is where a lead is lost. Turn the theme's
   "This collection is empty" into a sourcing invitation. Lives here, not in the theme, so it
   survives an update. */
(function () {

  function buildEnquiryDrawer(title) {
    var types = ['My home', 'A design firm or architect', 'Hospitality or commercial', 'A private estate or developer'];
    var times = ['Ready when it is ready', 'Within 1 to 3 months', '3 to 6 months', 'Flexible, still exploring'];
    var qtys = ['One', '2 to 5', '6 or more'];
    function opts(list, blank) {
      var out = '<option value="">' + blank + '</option>';
      for (var i = 0; i < list.length; i++) out += '<option value="' + list[i] + '">' + list[i] + '</option>';
      return out;
    }
    function group(id, label, control) {
      return '<div class="enquiry-field-group"><label for="' + id + '">' + label + '</label>' + control + '</div>';
    }
    return [
      '<div class="enquiry-form" data-enquiry>',
      '<button type="button" class="button button--primary enquiry-cta" aria-controls="amc-collection-enquiry" aria-expanded="false" data-enquiry-open>Tell us what you want</button>',
      '<x-drawer id="amc-collection-enquiry" class="drawer enquiry-drawer">',
      '<p class="h4" slot="header">Enquiry</p>',
      '<form method="post" action="/contact" id="amc-collection-enquiry-form" class="enquiry-form__form" accept-charset="UTF-8">',
      '<input type="hidden" name="form_type" value="contact">',
      '<input type="hidden" name="utf8" value="✓">',
      '<input type="hidden" name="contact[Looking for]" value="' + title + '">',
      '<div class="enquiry-progress" role="progressbar" aria-valuemin="1" aria-valuemax="2" aria-valuenow="1" data-enquiry-progress-bar>',
      '<span class="enquiry-progress__track"><span class="enquiry-progress__fill" data-enquiry-progress-fill></span></span>',
      '<span class="enquiry-progress__label" data-enquiry-progress>Step 1 of 2</span>',
      '</div>',
      '<div class="enquiry-step" data-enquiry-step="1">',
      group('amc-ce-vision', 'What are you looking for?', '<textarea id="amc-ce-vision" name="contact[Your vision]" rows="4" placeholder="For example: a pool table and a shuffleboard for a 20 x 16 ft room, dark walnut, fitted before December."></textarea>'),
      group('amc-ce-type', 'Where is it going?', '<select id="amc-ce-type" name="contact[Project type]" required>' + opts(types, 'Choose...') + '</select>'),
      group('amc-ce-time', 'When do you need it?', '<select id="amc-ce-time" name="contact[Timeline]" required>' + opts(times, 'Choose...') + '</select>'),
      group('amc-ce-qty', 'How many pieces?', '<select id="amc-ce-qty" name="contact[Quantity]" required>' + opts(qtys, 'Choose...') + '</select>'),
      '<button type="button" class="button button--primary enquiry-next" data-enquiry-next>Continue</button>',
      '</div>',
      '<div class="enquiry-step" data-enquiry-step="2" hidden>',
      group('amc-ce-name', 'Your name', '<input type="text" id="amc-ce-name" name="contact[name]" required autocomplete="name">'),
      group('amc-ce-email', 'Email', '<input type="email" id="amc-ce-email" name="contact[email]" required autocomplete="email">'),
      group('amc-ce-phone', 'Phone', '<input type="tel" id="amc-ce-phone" name="contact[phone]" autocomplete="tel">'),
      '<div class="enquiry-field-group enquiry-consent"><input type="checkbox" id="amc-ce-sms" name="contact[Text consent]" value="Yes" class="enquiry-checkbox"><label for="amc-ce-sms">Text me instead if that is easier. Message and data rates may apply. Reply STOP to opt out.</label></div>',
      '<button type="submit" class="button button--primary enquiry-submit">Send it to a specialist</button>',
      '<button type="button" class="enquiry-back" data-enquiry-back>Back</button>',
      '</div>',
      '<input type="text" name="contact[company]" class="enquiry-hp" style="display:none" tabindex="-1" aria-hidden="true">',
      '</form></x-drawer></div>'
    ].join('');
  }
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.empty-state .prose'), function (host) {
      if (host.dataset.amcEmptyDone === '1') return;
      var p = host.querySelector('p');
      if (!p || !/collection is empty/i.test(p.textContent)) return;
      host.dataset.amcEmptyDone = '1';
      p.textContent = 'We are stocking this range now. Tell us what you are looking for and a specialist will source it for you, with a price and a lead time, usually within one business day.';
      var cta = host.querySelector('a.button');
      if (cta && !host.querySelector('[data-enquiry-open]')) {
        var title = (document.querySelector('.collection-banner h1, .empty-state h1') || {}).textContent || 'this range';
        var holder = document.createElement('div');
        holder.innerHTML = buildEnquiryDrawer(title.trim());
        while (holder.firstChild) cta.parentNode.insertBefore(holder.firstChild, cta);
        cta.remove();
        cta = host.querySelector('[data-enquiry-open]');
      }
      if (!host.querySelector('.amc-empty-alt')) {
        var alt = document.createElement('p');
        alt.className = 'amc-empty-alt';
        alt.innerHTML = '<a href="/collections/all">Or browse everything we stock</a>';
        if (cta && cta.parentNode) cta.parentNode.insertBefore(alt, cta.nextSibling);
        else host.appendChild(alt);
      }
    });
  }
  window.amcEmptyRun = run;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 600);
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 300); });
})();

/* Products with no price yet are quote-only. Never print "$0.00" at a customer. */
(function () {
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-info .price-list'), function (list) {
      var text = (list.textContent || '').replace(/\s+/g, ' ');
      if (text.indexOf('$0.00') === -1) return;
      if (list.dataset.amcZero === '1') return;
      list.dataset.amcZero = '1';
      var ref2 = list.querySelector('sale-price, .price, [class*="h4"], [class*="h6"]');
      var cls2 = (ref2 && ref2.className ? ref2.className : 'h4 text-subdued').toString();
      list.innerHTML = '<span class="' + cls2 + '">Price on request</span>';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 600);
  setTimeout(run, 1800);
  document.addEventListener('variant:change', function () { setTimeout(run, 300); });
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 300); });
})();

/* Quote-only products sit at zero price and are blocked from sale, which makes Shopify print
   "Sold out" and "$0.00" on their collection cards. That is the wrong message: these pieces are
   not sold out, they are quoted. Fix the card, not the product: no sold out badge, and
   "Price on request" instead of a zero. Scoped to cards so product pages are untouched. */
(function () {
  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-card'), function (card) {
      if (card.dataset.amcQuote === '1') return;
      var price = card.querySelector('.price-list');
      if (!price) return;
      if ((price.textContent || '').indexOf('$0.00') === -1) return;
      card.dataset.amcQuote = '1';
      var ref = card.querySelector('.price-list sale-price, .price-list .price, .price-list [class*="h4"], .price-list [class*="h6"]');
      var cls = (ref && ref.className ? ref.className : 'h4 text-subdued').toString();
      price.innerHTML = '<span class="' + cls + '">Price on request</span>';
      Array.prototype.forEach.call(card.querySelectorAll('sold-out-badge, .badge--sold-out'), function (badge) {
        badge.style.display = 'none';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 500);
  setTimeout(run, 1500);
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 300); });
})();
